import React from "react";
import { connect } from "react-redux";
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Divider,
  Paper,
  Typography,
  Container,
  withStyles,
  Box,
  Card,
  CardContent,
  FormControl,
  InputAdornment,
  SvgIcon,
} from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import { PatientActions } from "../../redux/actions/PatientActions";
import { DocumentActions } from "../../redux/actions/DocumentAction";
import DocumentRecordList from './DocumentRecordList'
import { history } from "../helpers/History";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { USER_ROLE } from "../security/UserRole";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";
import Fab from "@material-ui/core/Fab";
import moment from "moment";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
  },
  table: {
    marginTop: theme.spacing(2),
    // display: "flex",
    // flexDirection: "column",
    alignItems: "center",
    // transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
    minHeight:250
  },avatar: {
    margin: theme.spacing(3),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
});

class DocumentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId: (this.props.userRole === USER_ROLE.PATIENT) ? this.props.patientId  : "",
      isCancelled :false,
    };
  }

  componentDidMount() {
    this.props.getDocumentByPatientId(this.props.patientId);
  }

  findDayDIff(assignedDate){
    if(!assignedDate){
      return 2;
    }
    let currentDate = new Date();
    let result = moment(currentDate).diff(assignedDate, 'days');
    return result;
  }
  
  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Action Item</title>
        </Helmet>

        <Container component="main" fixed={false} className={classes.main}>
          <CssBaseline />
          
              <form
                className={classes.form}
                noValidate
                name="form"
              >
                <Box display="flex" p={1} m={1}>
                  <Box p={1} flexGrow={1}>
                    <Typography
                      gutterBottom
                      variant="h4"
                      color="primary"
                      className={classes.typography}
                    >
                      {"Action Item(s)"}
                    </Typography>
                  </Box>
                </Box>
              </form>
            {this.props.documentList && this.props.documentList.map((value)=>{
              return (<Box clone m={2} borderRadius={4} boxShadow={3} key={value.id}>
                <Paper elevation={3}>
                  <Box display="flex" fontWeight="fontWeightBold" p={1}>
                    {this.findDayDIff(value.assignedDate)>0 ?
                      <Typography>
                      {'Action item(s) pending '+value.displayName+'. '+this.findDayDIff(value.assignedDate)+' days, '}
                        {'please '}
                        <Link onClick={()=>{history.push(`/document/upload/${value.id}`);}}>
                          click here
                        </Link>
                        {' to complete '}
                        
                        
                      </Typography>
                      :
                      <Typography>
                      {'Action item(s) pending '+value.displayName+'. '}
                        {' Please '}
                        <Link onClick={()=>{history.push(`/document/upload/${value.id}`);}}>
                          click here
                        </Link>
                        {' to complete '}
                        
                        
                      </Typography>

                    }
                    
                  </Box>
                </Paper>
              </Box>)
            })}
              

            
              
               
              
            
          
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const documentList = state.document.pending;
  const patientId = state.authentication.user.patientId;
  return { patientId,documentList};
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDocumentByPatientId: (id) => dispatch(DocumentActions.getPendingDocRequest(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DocumentList));
